import {
  BadgeCheck,
  Boxes,
  ShieldCheck,
  Compass,
  MapPin,
  HeartHandshake,
} from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { WHY_US } from "./data";

const ICONS = { BadgeCheck, Boxes, ShieldCheck, Compass, MapPin, HeartHandshake };

export default function WhyUs() {
  return (
    <section id="why-us" className="relative bg-coal py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <Eyebrow>Why Choose Lift Edge</Eyebrow>
          <SectionTitle>
            Built on Trust. <span className="text-edge">Backed by Service.</span>
          </SectionTitle>
        </Reveal>

        <div className="grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title} delay={i * 0.06} className="h-full">
                <div
                  className="group flex h-full flex-col bg-coal p-8 transition-colors duration-300 hover:bg-card"
                  data-testid={`why-choose-us-card-${i + 1}`}
                >
                  <div className="mb-6 flex h-12 w-12 items-center justify-center border border-line text-edge transition-colors duration-300 group-hover:border-edge group-hover:bg-edge group-hover:text-white">
                    <Icon size={22} strokeWidth={1.8} />
                  </div>
                  <span className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white">
                    {w.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ash">{w.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
